module.exports = __webpack_public_path__ + "static/media/edit.67daa52e.svg";